module.exports = __webpack_public_path__ + "img/medical_icon03.20ab9ac7.png";